export default "__VITE_ASSET__BrrF9g_k__"